-- | Widgets for displaying a select value as inline text. `hiddenSelect`
-- | includes an edit control that opens the real select widget, while
-- | `hiddenSelectLabel` is read-only.
module Widgets.HiddenSelect where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Widgets.BetterSelect (Select, selectWidget, selectedItem)

hiddenSelect :: forall a. Select a -> Widget HTML (Select a)
hiddenSelect state = do
    let label = fromMaybe (lookupTranslation "none") (_.label <$> selectedItem state)
    -- First, just render the label with the edit button.
    _ <- D.div
        [ P.className "hidden-select" ]
        [ D.p' [ D.text label ]
        , D.button
            [ P.className "hidden-select-edit-button"
            , P.onClick ]
            [ D.text $ lookupTranslation "edit" ]
        ]
    -- If edit is clicked, that returns and we render the select box.
    selectWidget state

hiddenSelectLabel :: forall a b. Select a -> Widget HTML b
hiddenSelectLabel state =
    D.div
        [ P.className "hidden-select" ]
        [ D.p' [ D.text label ] ]
  where
    label = fromMaybe (lookupTranslation "none") (_.label <$> selectedItem state)

hiddenSelectDisabled :: forall a b. Select a -> Widget HTML b
hiddenSelectDisabled state =
    D.div
        [ P.className "hidden-select" ]
        [ D.p' [ D.text label ]
        , D.button
            [ P.className "hidden-select-edit-button"
            , P.disabled true
            , P._type "button"
            ]
            [ D.text $ lookupTranslation "edit" ]
        ]
  where
    label = fromMaybe (lookupTranslation "none") (_.label <$> selectedItem state)
